export const ITR_toggleRightSidebarReducer = {
  ITR_toggleRightSidebar: (state, action) => {
    const { rightSidebarOpenFlag, uploadITRFileBtnClicked } = action.payload;
    state.rightSidebarOpenFlag = rightSidebarOpenFlag;
    state.uploadITRFileBtnClicked = uploadITRFileBtnClicked;
  },
};
